export default "<p-checkbox [(ngModel)]=\"value\" label=\"{{filter.Title}}\"  binary=\"true\" (onChange)=\"onChange($event)\"></p-checkbox>\r\n";